import { Injectable } from '@angular/core';
import {
  PopupService
} from "../../../../../kernel/popups/popup/modules/confirmation-dialog/services/confirmation-popup/popup.service";
import {
  RejectSubscriptionPopupComponent
} from "../components/reject-subscription-popup/reject-subscription-popup.component";
import {ListingItemInterface} from "../../../../../kernel/listing/interfaces/listing-item.interface";
import {SubscriptionApiService} from "./subscription-api.service";
import {ISubscriptionRejectionReason} from "../interfaces/reject-subscription-reason.interface";
import {ESubscriptionStatus} from "../enums/subscription-status.enums";
import {filter, from, of, switchMap, tap} from "rxjs";
import {
  VerifySubscriptionPopupComponent
} from "../components/verify-subscription-popup/verify-subscription-popup.component";
import {
  AcceptSubscriptionPopupComponent
} from "../components/accept-subscription-popup/accept-subscription-popup.component";
import {EMasriVerificationStatus} from "../enums/masri-verification-status.enum";

@Injectable()
export class SubscriptionService {

  constructor(
    private popupService: PopupService,
    private subscriptionApiService: SubscriptionApiService
  ) {
  }


  rejectSubscription(row: ListingItemInterface) {
    return from(this.openRejectionSubscriptionPopup()).pipe(
      filter((reasons): reasons is ISubscriptionRejectionReason[] => Array.isArray(reasons) && reasons.length > 0),
      switchMap((reasons) =>
        this.subscriptionApiService.rejectSubscription(row.get('id'), reasons).pipe(
          tap(() => row.set('status', ESubscriptionStatus.REJECTED))
        )
      )
    )
  }

  acceptSubscription(row: ListingItemInterface) {
    return from(this.openAcceptSubscriptionPopup()).pipe(
      filter((result): result is {status: boolean, masriId: number} => result.status),
      switchMap((result) =>
        this.subscriptionApiService.acceptSubscription(row.get('id'), result.masriId).pipe(
          tap(() => row.set('status', ESubscriptionStatus.ACTIVE))
        )
      )
    )
  }

  private openRejectionSubscriptionPopup(): Promise<ISubscriptionRejectionReason[] | undefined> {
    return this.popupService.open(
      {
        showHeader: false,
        width: '600px',
      },
      RejectSubscriptionPopupComponent
    );
  }

  private openAcceptSubscriptionPopup(): Promise<{status: boolean, masriId: number}> {
    return this.popupService.open(
      {
        showHeader: false,
        width: '600px',
      },
      AcceptSubscriptionPopupComponent
    );
  }

  verifySubscription(row: ListingItemInterface) {
    return from(this.openVerifySubscriptionPopup(row))
      .pipe(
        filter((result) => [
          EMasriVerificationStatus.NOT_FOUND,
          EMasriVerificationStatus.NOT_ALLOWED,
          EMasriVerificationStatus.ALLOWED
        ].includes(result as EMasriVerificationStatus)),
        tap((result) => {
          switch (result as EMasriVerificationStatus) {
            case EMasriVerificationStatus.ALLOWED: row.set('status', ESubscriptionStatus.ACTIVE); break;
            case EMasriVerificationStatus.NOT_ALLOWED: row.set('status', ESubscriptionStatus.REJECTED); break;
            case EMasriVerificationStatus.NOT_FOUND: row.set('hasMasriJob', true); break;
          }
        })
      )
  }

  openVerifySubscriptionPopup(row: ListingItemInterface) {
    return this.popupService.open(
      {
        showHeader: false,
        width: '470px',
        data: { subscription: row.getData() }
      },
      VerifySubscriptionPopupComponent
    )
  }

}
